import React from 'react';
import { Box, ButtonGroup, Button, Typography, IconButton } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export default function PaginationControls({
  pageSize,
  onPageSizeChange,
  currentPage,
  totalEvents,
  onPreviousPage,
  onNextPage,
  hasMore
}) {
  const startEvent = (currentPage - 1) * pageSize + 1;
  const endEvent = Math.min(currentPage * pageSize, totalEvents);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      {/* Event Count */}
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
        {startEvent}-{endEvent}{hasMore ? '+' : ''}
      </Typography>

      {/* Page Size */}
      <ButtonGroup size="small" variant="outlined">
        <Button
          onClick={() => onPageSizeChange(20)}
          variant={pageSize === 20 ? 'contained' : 'outlined'}
          sx={{ minWidth: 40, fontSize: '0.7rem', py: 0.25 }}
        >
          20
        </Button>
        <Button
          onClick={() => onPageSizeChange(50)}
          variant={pageSize === 50 ? 'contained' : 'outlined'}
          sx={{ minWidth: 40, fontSize: '0.7rem', py: 0.25 }}
        >
          50
        </Button>
        <Button
          onClick={() => onPageSizeChange(100)}
          variant={pageSize === 100 ? 'contained' : 'outlined'}
          sx={{ minWidth: 40, fontSize: '0.7rem', py: 0.25 }}
        >
          100
        </Button>
      </ButtonGroup>

      {/* Prev/Next Navigation */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
        <IconButton
          size="small"
          onClick={onPreviousPage}
          disabled={currentPage === 1}
          sx={{ p: 0.5 }}
        >
          <NavigateBeforeIcon fontSize="small" />
        </IconButton>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', minWidth: 20, textAlign: 'center' }}>
          {currentPage}
        </Typography>
        <IconButton
          size="small"
          onClick={onNextPage}
          disabled={!hasMore}
          sx={{ p: 0.5 }}
        >
          <NavigateNextIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
